import styled from "styled-components";
import { fonts } from "../../components/common/mixins";

export const Title = styled.h1`
  ${fonts.midtitle()};
  margin: 0;
`;